import { createRouter, createWebHistory } from 'vue-router';

// 이벤트 페이지 라우트 설
const routes = [
    {
        path: '/',
        name: 'Home',
        meta: { title: '차일디, 우리 아이 차일디로 입히다', subTitle: '메인', mainHeader: true },   //meta.mainHeader => true: 헤더노출 / false: 헤더비노출
        component: () => import('../event/test/index.vue'), // HOME 페이지 컴포넌트를 로드
    },
    {
        path: '/event/test',
        name: 'EventTest1',
        meta: { title: '', subTitle: '이벤트1', mainHeader: true },
        component: () => import('../event/test/index.vue'), // 동적 import로 첫 번째 이벤트 페이지 컴포넌트를 로드
    },
    {
        path: '/event/test2',
        name: 'EventTest2',
        meta: { title: '', subTitle: '이벤트2', mainHeader: true },
        component: () => import('../event/test2/index.vue'), // 동적 import로 두 번째 이벤트 페이지 컴포넌트를 로드
    },
    {
        path: '/brands/',
        name: 'BrandsList',
        meta: { title: '브랜드', subTitle: '브랜드', mainHeader: false },
        component: () => import('../brands/list.vue'), // 브랜드 리스트
    },
    {
        path: '/brands/:brandName',
        name: 'Brands',
        meta: { title: ':brandName', subTitle: ':brandName', mainHeader: false },
        component: () => import('../brands/index.vue'), // 브랜드 상세
    },
    {
        path: '/showcase/:brand/:id',
        name: 'ShowcaseDetail',
        component: () => import('@/views/showcase/ShowcaseDetail.vue'),
        props: true
    },
    // 추가 이벤트 페이지는 여기에...
];

// Vue Router 인스턴스를 생성하고, 이벤트 라우트만을 설정합니다.
const router = createRouter({
    history: createWebHistory(),
    routes, // 단축 구문을 사용하여 routes 배열을 직접 전달
})

function removeState() {
    const currentURL = window.location.href;
    if (window.location.href === 'http://localhost:8080/brands' || window.location.href === 'http://localhost:8080/brands/' || window.location.href === 'https://event.childy.co.kr/brands/' || window.location.href === 'https://event.childy.co.kr/brands') {
        localStorage.clear();
    }

    window.onpageshow = function (event) {
        if (event.persisted || (window.performance && window.performance.navigation.type == 2)) {
            // Back Forward Cache로 브라우저가 로딩될 경우 혹은 브라우저 뒤로가기 했을 경우
            localStorage.clear();
        }
    }
}
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        let title = to.meta.title
        if (title.includes(':brandName')) {
            const brandName = to.params.brandName // 동적으로 변경되는 부분 가져오기
            title = title.replace(':brandName', brandName) // 동적 값으로 제목 설정
        }
        updatePageTitle(`${title} | 차일디`)
    }

    removeState(); // 여기서 호출됩니다.


    next()
})


function goBack() {
    router.go(-1); // 또는 router.back();
}


// export default router;
export { goBack, router as default }